module.exports = __webpack_public_path__ + "img/taobao1.eac8ba06.png";